export default [
  {
    path: "/menu",
    component: resolve => require(["@/views/menu.vue"], resolve),
    redirect: "/menu/home",
    children: [
      {
        path: "content",
        component: resolve => require(["@/views/content/index.vue"], resolve),
        children: [
          {
            path: "video/list",
            name: "videolist",
            component: resolve => require(["@/modules/video/pages/list.vue"], resolve)
          },
          {
            path: "video/type",
            name: "videoType",
            component: resolve => require(["@/modules/video/pages/videoType.vue"], resolve)
          },
          {
            path: "video/home",
            name: "videoHome",
            component: resolve => require(["@/modules/video/pages/videoHome.vue"], resolve)
          },
          {
            path: "video/banner",
            name: "videobanner",
            component: resolve => require(["@/modules/video/pages/banner.vue"], resolve)
          }
        ]
      }
    ]
  }
];